import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './common'
import '../scss/style.scss'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { hashHistory, Redirect, Route, Router } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import Dati from './components/buy/smart/Data'
import Restore from './components/buy/smart/Restore'
import Thanks from './components/buy/smart/Thanks'
import SpinLoader from './components/dumb/SpinLoader'
import DocumentiNlt from './components/noleggia/smart/DocumentiNlt'
import NoleggiaWrapper from './components/noleggia/smart/NoleggiaWrapper'
import RentRegister from './components/noleggia/smart/RentRegister'
import ScegliCanone from './components/noleggia/smart/ScegliCanone'
import ServiziPlus from './components/noleggia/smart/ServiziPlus'
import { GA_EVENTS } from './components/triggerDataLayerEvent'
import { store } from './store/Buy'
import { initSentry } from './utils/sentryUtils'

const registerH2 = (
  <h2 className={'intro'}>
    Ancora pochi passi e guiderai la tua auto: lasciaci i contatti per
    proseguire con la richiesta di noleggio e la{' '}
    <b>personalizzazione di servizi e canone</b>
  </h2>
)

const routes = (
  <Route component={NoleggiaWrapper}>
    <Route component={Restore} path="/restore/:id_ordine/:id_token" />
    <Route
      component={() => (
        <RentRegister
          GA_registerEvent={GA_EVENTS.leadSelloutNoleggia}
          h2={registerH2}
          idLead={'registrazione_noleggio'}
          next="/scegli-canone"
          showPrenota={false}
        />
      )}
      path="/register"
    />
    <Route component={ScegliCanone} path="/scegli-canone" />
    <Route component={ServiziPlus} path="/servizi-plus" />
    <Route component={Dati} path="/richiesta-noleggio" />
    <Route component={DocumentiNlt} path="/documents" />
    <Route component={Thanks} path="/thank-you" />
    <Route
      component={() => <Thanks isNltBrumbrumTyFirmato />}
      path="/thank-you-firma-completata"
    />
  </Route>
)

initSentry(routes)

render(
  <SpinLoader ui={{ fetching: true }} />,
  document.getElementById('react-spa-wrapper')
)

function renderApp() {
  const history = syncHistoryWithStore(hashHistory, store)

  render(
    <Provider store={store}>
      <Router history={history}>
        {routes}
        <Redirect from="/" to="register" />
      </Router>
    </Provider>,
    document.getElementById('react-spa-wrapper')
  )
}

/**
 * TS-2097
 * la gestione seguente ci serve per attendere
 * che Google Optimize abbia terminato il suo caricamento
 * altrimenti potrebbe fare il redirect dopo che l'app
 * si e' renderizzata ed ha mangiato parametri su url
 * risultando in un redirect con dei parametri assenti
 */
window.renderApp = renderApp

if (window.optimizeIsReady) {
  renderApp()
} else {
  window.optimizeRenderAppTimeout = setTimeout(() => {
    // comunica ad optimize che e' arrivato in ritardo
    window.dataLayer.hide.end = null
    renderApp()
  }, 4000)
}
